function Footer(){
    return <>
    <a href="#no-link" className="fixed z-10 opacity-100 bottom-5 right-5">
        <div className="transform rounded-full shadow-sm hover:shadow-2xl animation-smooth hover:-translate-y-1 group" data-toggle="tooltip" data-tippy-content="Help">
            <div className="flex items-center justify-center w-16 h-16 rounded-full group-hover:bg-white bg-neutral-200 animation-smooth">
                <i className="text-3xl ph-lifebuoy"></i>
            </div>
        </div>
    </a>

    <footer className="sticky bottom-0 mt-auto text-white bg-neutral-900">
        <div className="flex justify-between px-5 py-5">
            <nav className="flex space-x-2">
                <p>Designed by <a className="font-bold hover:text-secondary-300 animation-smooth" href="https://missing.tech/">Missing.tech</a> | Copyright 2022©</p>
            </nav>
            <span className="text-sm"></span>
        </div>
    </footer>
    </>;
}

export default Footer;